export const prepordNewrelicConfig = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ["bam.nr-data.net"] },
  }, // NREUM.init
  info: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: "NRJS-c1357199d88cffaa41a",
    applicationID: "1120295027",
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: "4423431",
    trustKey: "4423431",
    agentID: "1120295027",
    licenseKey: "NRJS-c1357199d88cffaa41a",
    applicationID: "1120295027",
  },
};

export const pordNewrelicConfig = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ["bam.nr-data.net"] },
  }, // NREUM.init
  info: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: "NRJS-c1357199d88cffaa41a",
    applicationID: "1120295028",
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: "4423431",
    trustKey: "4423431",
    agentID: "1120295028",
    licenseKey: "NRJS-c1357199d88cffaa41a",
    applicationID: "1120295028",
  },
};
